import { liveTicker } from "@/mocks/chigua";
import Tag from "./Tag";

const matchup = [
  { name: "瓜小满", sub: "上半区 · 种子瓜位", ratio: 78, tone: "bg-primary-500", ring: "text-primary-700 bg-primary-100" },
  { name: "月半瓜", sub: "上半区 · 人气黑马", ratio: 71, tone: "bg-accent-500", ring: "text-accent-700 bg-accent-100" },
];

export default function Scoreboard() {
  return (
    <section id="live" className="relative overflow-hidden bg-accent-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-1.5 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="inline-flex items-center gap-1.5 text-sm font-bold uppercase tracking-wide text-accent-700">
              <span className="h-2 w-2 rounded-full bg-accent-500 chg-pulse"></span>
              Live · 实时动态速递
            </p>
            <h2 className="mt-2 font-heading text-3xl leading-tight text-foreground-950 md:text-4xl">
              赛况一秒不落，逐条刷新
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600">
            每日战报与节点动态持续速递，当前轮次、晋级走向、对决预告一目了然，吃瓜全程不掉队。
          </p>
        </div>

        <div className="mt-9 grid gap-5 lg:grid-cols-5">
          {/* 今日焦点对局 */}
          <article className="overflow-hidden rounded-3xl bg-background-50 p-6 lg:col-span-2">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg text-foreground-950">今日焦点对局</h3>
              <Tag tone="primary">半决赛 1 · 今晚 20:00</Tag>
            </div>

            <div className="mt-5 grid grid-cols-2 items-stretch gap-3">
              {matchup.map((m, idx) => (
                <div key={m.name} className="flex flex-col items-center gap-2 rounded-2xl bg-background-100 p-4 text-center">
                  <span className={`flex h-14 w-14 items-center justify-center rounded-full font-heading text-xl ${m.ring}`}>
                    {m.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="font-heading text-base leading-none text-foreground-950">{m.name}</p>
                    <p className="mt-1 text-[11px] text-foreground-500">{m.sub}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-2 flex items-center justify-center gap-2 text-foreground-500">
              <span className="h-px flex-1 bg-background-200"></span>
              <span className="rounded-full bg-foreground-950 px-2.5 py-0.5 font-label text-xs font-extrabold text-background-50">VS</span>
              <span className="h-px flex-1 bg-background-200"></span>
            </div>

            <div className="mt-4 space-y-3.5">
              {matchup.map((m) => (
                <div key={m.name}>
                  <div className="mb-1 flex items-center justify-between text-sm">
                    <span className="font-medium text-foreground-700">{m.name}</span>
                    <span className="font-label font-bold text-foreground-900">{m.ratio}%</span>
                  </div>
                  <div className="h-2.5 overflow-hidden rounded-full bg-background-200">
                    <div className={`h-full rounded-full ${m.tone}`} style={{ width: `${m.ratio}%` }}></div>
                  </div>
                </div>
              ))}
            </div>

            <p className="mt-4 rounded-xl bg-secondary-100 px-3.5 py-2.5 text-xs leading-relaxed text-secondary-800">
              <i className="ri-information-line mr-1" aria-hidden="true"></i>
              本轮投票已于 19:30 开启，开赛后 30 分钟关闭，支持率数据每 60 秒自动刷新。
            </p>
          </article>

          {/* 实时动态速递列表 */}
          <article className="flex flex-col rounded-3xl bg-background-50 p-6 lg:col-span-3">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg text-foreground-950">速递列表 · 实时更新</h3>
              <span className="inline-flex items-center gap-1.5 text-xs text-accent-700">
                <span className="h-1.5 w-1.5 rounded-full bg-accent-500 chg-pulse"></span>
                自动轮播
              </span>
            </div>

            <div className="relative mt-4 flex-1 overflow-hidden" style={{ minHeight: 320 }}>
              <div className="chg-ticker space-y-2.5">
                {[...liveTicker, ...liveTicker].map((it, i) => (
                  <div key={i} className="flex items-start gap-3 rounded-2xl bg-background-100/80 px-4 py-3">
                    <Tag tone={it.tagTone}>{it.tag}</Tag>
                    <p className="flex-1 text-sm leading-relaxed text-foreground-800">{it.text}</p>
                    <span className="whitespace-nowrap text-xs text-foreground-500">{it.time}</span>
                  </div>
                ))}
              </div>
              <div className="pointer-events-none absolute inset-x-0 bottom-0 h-12 bg-gradient-to-t from-background-50 to-transparent"></div>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}